import CryptoTransactionWidget from '../components/CryptoTransactionWidget';
import './Bridge.css';

function Bridge() {
  return (
    <div className="bridge-container">
      <CryptoTransactionWidget />
    </div>
  );
}

export default Bridge;